// 引入axios
import axios from 'axios';
const {SUCCESS,ADMIN_TOKEN_ERR} = require("../util/error");
const util = require("../util/util").default;
// 自定义判断元素类型JS
function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}

// 参数过滤函数
function filterNull(o) {
  for (let key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}

/*
  接口处理函数
*/
function apiAxios(root, method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }
  // if (params instanceof FormData) {
  //     params.append('access_token', localStorage.getItem('admin_access_token'))
  // } else {
  //     params.access_token = localStorage.getItem('admin_access_token')
  // }
  axios({
    method: method,
    url: url,
    headers: {'token':  util.getToken()},
    data: method === 'POST' || method === 'PUT' || method === 'DELETE' ? params : null,
    params: method === 'GET' ? params : null,
    baseURL: root,
    withCredentials: false
  })
    .then(function (res) {
      if (res.data.errcode === SUCCESS) {
        if (success) {
          success(res.data)
        }
      } else if (res.data.errcode === ADMIN_TOKEN_ERR) {
        util.gotoLogin()
      } else {
        console.log('XHR RES: ' + JSON.stringify(res))
        if (failure) {
          failure(res.data)
        }
      }
    })
    .catch(function (err) {
      if (err) {
        console.log('err: ' + err)
      }
    })
}

const v1Base = '/api/v1';
export const rootV1 = {
  get: function (url, params, success, failure) {
    return apiAxios(v1Base, 'GET', url, params, success, failure)
  },
  post: function (url, params, success, failure) {
    return apiAxios(v1Base, 'POST', url, params, success, failure)
  },
  put: function (url, params, success, failure) {
    return apiAxios(v1Base, 'PUT', url, params, success, failure)
  },
  delete: function (url, params, success, failure) {
    return apiAxios(v1Base, 'DELETE', url, params, success, failure)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js